<template>
  <div>
    <v-data-table
      item-key="id"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      :headers="getHeader()"
      :items="users"
      :search="search"
      :options.sync="localOptions"
      :server-items-length="totalUsers"
    >
      <template v-slot:top>
        <div class="table-search-bar">
          <v-icon color="grey" size="20" class="mr-2">mdi-magnify</v-icon>
          <input
            v-model="search"
            :placeholder="$t('pages.search') + '...'"
            class="table-search-input"
          />
        </div>
      </template>

      <!-- Modulet e nje organizate, te ndezshme ketu per ta mos hapur
           secilen me vete. -->
      <template v-slot:item.modules="{ item }">
        <div class="modulet">
          <div v-for="m in modulet" :key="m.key" class="modulet__njesi">
            <v-switch
              :input-value="gjendja(item.id, m.key)"
              :disabled="dukeNdryshuar === item.id + ':' + m.key"
              color="success"
              dense
              hide-details
              class="mt-0 pt-0"
              @change="ndryshoModulin(item, m.key, $event)"
            ></v-switch>
            <span v-if="modulet.length > 1" class="modulet__emer">
              {{ emri(m) }}
            </span>
          </div>
        </div>
      </template>

      <template v-slot:item.status_id="{ item }">
        <v-chip :color="getStatusColor(item.status_id)" dark small>
          {{ getStatusValue(item.status_id) }}
        </v-chip>
      </template>

      <template v-slot:item.name="{ item }">
        <div class="user-cell">
          <v-avatar rounded size="36" class="user-avatar">
            <v-img :src="getAvatarUrl(item.avatar)"></v-img>
          </v-avatar>
          <div class="user-cell-info">
            <span class="user-cell-name">{{ item.name }}</span>
            <span class="user-cell-email">{{ item.email }}</span>
          </div>
        </div>

        <v-tooltip
          v-if="item.expired != null && item.expired"
          bottom
          color="info"
        >
          <template v-slot:activator="{ on }">
            <v-icon color="error" v-on="on"> mdi-cancel </v-icon>
          </template>
          <span>One or more of the driver's documents have expired</span>
        </v-tooltip>
      </template>

      <template
        v-if="userType === 'students'"
        v-slot:item.parent_name="{ item }"
      >
        <div style="display: flex; align-items: center; gap: 6px">
          <v-avatar rounded size="38">
            <v-img :src="getAvatarUrl(item.parent_avatar)"></v-img>
          </v-avatar>
          <div style="display: flex; flex-direction: column">
            <span>
              {{ item.parent_name }}
            </span>
            <!--            <span>-->
            <!--              {{ item.parent_email }}-->
            <!--            </span>-->
          </div>
        </div>
      </template>

      <template v-if="userType === 'guardians'" v-slot:item.role_id="{ item }">
        <v-chip dark :color="item.role_id === 4 ? 'primary' : 'info'">
          {{ item.role_id === 4 ? 'Parent' : 'Guardian' }}
        </v-chip>
      </template>

      <template v-slot:item.school_name="{ item }">
        <span v-if="item.school_name">
          {{ item.school_name }}
        </span>
        <span v-else>-</span>
      </template>

      <template v-slot:item.group_name="{ item }">
        <span v-if="item.group_name">
          {{ item.group_name }}
        </span>
        <span v-else>-</span>
      </template>

      <template v-if="userType === 'drivers'" v-slot:item.bus="{ item }">
        <div v-if="item.buses" class="bus-chips">
          <v-chip
            v-for="bus in item.buses"
            :key="bus.id"
            small
            dark
            class="bus-chip"
            @click="$emit('assignBus', bus)"
            :color="getBusAssignmentColor(bus)"
          >
            {{ bus != null ? bus.name : $t('pages.no_bus') }}
          </v-chip>
        </div>
        <div v-else class="bus-chips">
          <v-chip
            small
            dark
            class="bus-chip"
            @click="$emit('assignBus')"
            :color="getBusAssignmentColor()"
          >
            {{ item.bus != null ? item.bus.name : $t('pages.no_bus') }}
          </v-chip>
        </div>
      </template>

      <template v-slot:item.created_at="{ item }">
        <small>{{ item.created_at | moment('DD/MM/YYYY') }}</small> -
        <small class="text-muted">
          {{ item.created_at | moment('HH:mm') }}
        </small>
      </template>

      <template v-slot:item.last_login_at="{ item }">
        <small v-if="item.last_login_at">
          {{ item.last_login_at | moment('DD/MM/YYYY') }}
        </small>
        -
        <small class="text-muted" v-if="item.last_login_at">
          {{ item.last_login_at | moment('HH:mm') }}
        </small>
      </template>

      <template v-slot:item.student_settings.morning_bus="{ item }">
        <v-tooltip
          v-if="tab < 2 && userType === 'students' && mode === 'simple'"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              dark
              @click="!$isDirector && $emit('set-student-bus', item, 1)"
              :style="$isDirector ? 'cursor: default' : ''"
              :color="getBusAssignmentColor(item.student_settings.morning_bus)"
            >
              {{
                item.student_settings.morning_bus != null
                  ? item.student_settings.morning_bus.license
                  : $t('pages.no_bus')
              }}
            </v-chip>
          </template>
          <span>Set morning bus</span>
        </v-tooltip>
      </template>
      <template v-slot:item.student_settings.afternoon_bus="{ item }">
        <v-tooltip
          v-if="tab < 2 && userType === 'students' && mode === 'simple'"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              dark
              @click="!$isDirector && $emit('set-student-bus', item, 0)"
              :style="$isDirector ? 'cursor: default' : ''"
              :color="
                getBusAssignmentColor(item.student_settings.afternoon_bus)
              "
            >
              {{
                item.student_settings.afternoon_bus != null
                  ? item.student_settings.afternoon_bus.license
                  : $t('pages.no_bus')
              }}
            </v-chip>
          </template>
          <span>Set afternoon bus</span>
        </v-tooltip>
      </template>

      <template v-slot:item.actions="{ item }">
        <!-- <v-tooltip v-if="tab == 2" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              class="mr-2 primary"
              @click="$emit('view-user', item)"
            >
              <v-icon small class="mr-2">
                mdi-card-account-mail-outline
              </v-icon>
              Take Action
            </v-btn>
          </template>
          <span>Approve or Reject</span>
        </v-tooltip> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon x-small color="info" class="mr-1" @click="$emit('view-user', item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('actions.view') }}</span>
        </v-tooltip>
        <v-tooltip v-if="tab == 0" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="checkIfLocationEnabled(item) && mode === 'simple'"
              v-bind="attrs" v-on="on" icon x-small color="success" class="mr-1"
              @click="$emit('show-student-location', item)"
            >
              <v-icon small>mdi-map-marker</v-icon>
            </v-btn>
          </template>
          <span>Pickup and drop-off locations</span>
        </v-tooltip>
        <v-tooltip v-if="tab < 2 && !$isDirector" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon x-small color="warning" class="mr-1" @click="$emit('edit-user', item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('actions.edit') }}</span>
        </v-tooltip>
        <v-tooltip v-if="tab < 2 && !$isDirector" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs" v-on="on" icon x-small class="mr-1"
              :color="item.status_id == 3 ? 'success' : 'error'"
              @click="$emit('suspend-user', item, users.indexOf(item))"
            >
              <v-icon small>{{ item.status_id == 3 ? icons.mdiAccountCheck : icons.mdiAccountOff }}</v-icon>
            </v-btn>
          </template>
          <span>{{ item.status_id == 3 ? $t('pages.activate') : $t('pages.suspend') }}</span>
        </v-tooltip>
        <v-tooltip v-if="tab != 2" bottom>
          <template v-slot:activator="{ on, attrs }">
            <!--            <v-icon-->
            <!--              v-if="userType === 'drivers' && item.bus"-->
            <!--              v-bind="attrs"-->
            <!--              v-on="on"-->
            <!--              small-->
            <!--              class="mr-2"-->
            <!--              @click="$emit('unassign-bus', item)"-->
            <!--            >-->
            <!--              mdi-fridge-industrial-off-->
            <!--            </v-icon>-->
            <!--            <v-icon-->
            <!--              v-else-if="userType === 'drivers'"-->
            <!--              v-bind="attrs"-->
            <!--              v-on="on"-->
            <!--              small-->
            <!--              class="mr-2"-->
            <!--              @click="$emit('assign-bus', item)"-->
            <!--            >-->
            <!--              mdi-bus-->
            <!--            </v-icon>-->
          </template>
          <span>{{ item.bus ? 'Un-assign bus' : 'Assign bus' }}</span>
        </v-tooltip>
        <v-tooltip v-if="tab != 2" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="userType === 'schools'" v-bind="attrs" v-on="on" icon x-small color="purple" class="mr-1" @click="$emit('login-as-school', item)">
              <v-icon small>mdi-login</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('actions.login_as_this_organisation') }}</span>
        </v-tooltip>
        <v-tooltip v-if="tab != 2" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="userType === 'schools'" v-bind="attrs" v-on="on" icon x-small color="error" class="mr-1" @click="$emit('delete-school', item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('actions.delete_this_school') }}</span>
        </v-tooltip>
        <v-tooltip v-if="tab != 2" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="(userType === 'students' || userType === 'guardians' || userType === 'drivers') && !$isDirector"
              v-bind="attrs" v-on="on" icon x-small color="error" class="mr-1"
              @click="$emit('delete-user', item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('actions.delete_this_user') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mdiAccountCheck, mdiAccountOff } from '@mdi/js';
import { Keys } from '@/config';
import axios from 'axios';
import { mesazhiIGabimit } from '@/utils/error-message';
import { debounce } from '@/utils/debounce';

export default {
  props: {
    users: Array,
    userType: String,
    tab: Number,
    mode: String,
    totalUsers: Number,
    options: Object,
  },
  components: {},
  data() {
    return {
      isLoading: false,
      search: '',
      // Modulet e platformes dhe gjendja e tyre per cdo organizate, te marra
      // njeheresh: nje thirrje per rresht do te ishte dhjetera per faqe.
      modulet: [],
      gjendjet: {},
      dukeNdryshuar: null,
      defaultsHeaders: [
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.status'), value: 'status_id' },
        { text: this.$t('table.last_login'), value: 'last_login_at' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
      driverHeaders: [
        // { text: this.$t('table.id'), value: 'id', align: 'start', filterable: false },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.email'), value: 'email' },
        { text: this.$t('table.bus'), value: 'bus' },
        { text: this.$t('table.status'), value: 'status_id' },
        { text: this.$t('table.last_login'), value: 'last_login_at' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
      studentAdvancedHeaders: [
        // {
        //   text: this.$t('table.id'),
        //   value: 'id',
        //   align: 'start',
        //   filterable: false,
        // },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.parent_name'), value: 'parent_name' },
        // { text: this.$t('table.parent_email'), value: 'parent.email' },
        { text: this.$t('table.school'), value: 'school_name' },
        { text: this.$t('table.class'), value: 'group_name' },
        { text: this.$t('table.status'), value: 'status_id' },
        { text: this.$t('table.last_login'), value: 'last_login_at' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
      studentSimpleHeaders: [
        // {
        //   text: this.$t('table.id'),
        //   value: 'id',
        //   align: 'start',
        //   filterable: false,
        // },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.parent_name'), value: 'parent.name' },
        { text: this.$t('table.parent_email'), value: 'parent.email' },
        { text: 'Morning Bus', value: 'student_settings.morning_bus' },
        { text: 'Afternoon Bus', value: 'student_settings.afternoon_bus' },
        { text: this.$t('table.status'), value: 'status_id' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
      parentHeaders: [
        // { text: this.$t('table.id'), value: 'id', align: 'start', filterable: false },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.email'), value: 'email' },
        { text: this.$t('table.role'), value: 'role_id' },
        { text: this.$t('table.status'), value: 'status_id' },
        { text: this.$t('table.last_login'), value: 'last_login_at' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
      statuses: [
        { value: this.$t('table.active'), color: 'success' },
        { value: this.$t('table.pending'), color: 'warning' },
        { value: this.$t('table.suspended'), color: 'error' },
        { value: this.$t('table.under_review'), color: 'error' },
        { value: this.$t('table.out_of_coins'), color: 'error' },
      ],
      icons: {
        mdiAccountCheck,
        mdiAccountOff,
      },
      localOptions: {},
    };
  },
  mounted() {
    this.merrModulet();
  },
  methods: {
    getStatusColor(status) {
      return this.statuses[status - 1].color;
    },
    emri(m) {
      const gjuha = localStorage.getItem('locale') === 'en' ? 'en' : 'sq';
      return m.name[gjuha] || m.name.en;
    },

    gjendja(schoolId, celes) {
      const e = this.gjendjet[schoolId];
      return !!(e && e[celes]);
    },

    async merrModulet() {
      if (this.userType !== 'schools') return;

      try {
        const { data } = await axios.get('/school-modules/all');
        this.modulet = data.modules || [];
        this.gjendjet = data.schools || {};
      } catch (e) {
        // Pa pergjigje kolona thjesht nuk shfaqet: lista e organizatave
        // duhet te punoje edhe pa te.
        this.modulet = [];
      }
    },

    async ndryshoModulin(organizata, celes, vlera) {
      const celesiNdryshimit = organizata.id + ':' + celes;
      this.dukeNdryshuar = celesiNdryshimit;

      try {
        await axios.post('/school-modules', {
          school_id: organizata.id,
          module: celes,
          enabled: vlera,
        });

        this.$set(this.gjendjet, organizata.id, {
          ...(this.gjendjet[organizata.id] || {}),
          [celes]: vlera,
        });
      } catch (e) {
        // Rikthehet: nje celes qe tregon dicka tjeter nga serveri eshte me
        // keq se nje gabim i dukshem.
        this.$set(this.gjendjet, organizata.id, {
          ...(this.gjendjet[organizata.id] || {}),
          [celes]: !vlera,
        });
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.dukeNdryshuar = null;
      }
    },

    getStatusValue(status) {
      return this.statuses[status - 1].value;
    },
    getBusAssignmentColor(bus) {
      return bus != null ? 'info' : 'error';
    },
    getHeader() {
      if (this.userType === 'drivers') return this.driverHeaders;
      if (this.userType === 'schools' && this.modulet.length) {
        // Para veprimeve: celesi eshte gjendje, jo veprim.
        const k = [...this.defaultsHeaders];
        k.splice(k.length - 1, 0, {
          text: this.$t('modules.title'),
          value: 'modules',
          sortable: false,
        });
        return k;
      }
      if (this.userType === 'students') {
        if (this.mode === 'simple') {
          return this.studentSimpleHeaders;
        } else {
          return this.studentAdvancedHeaders;
        }
      }
      if (this.userType === 'guardians') return this.parentHeaders;
      return this.defaultsHeaders;
    },
    checkIfLocationEnabled(item) {
      return (
        this.userType === 'students' &&
        item.student_settings != null &&
        ((item.student_settings.pickup_lat != null &&
          item.student_settings.pickup_lng != null) ||
          (item.student_settings.drop_off_lat != null &&
            item.student_settings.drop_off_lng != null))
      );
    },
    getAvatarUrl(avatar) {
      if (avatar) {
        return (this.avatarImageUrl = Keys.VUE_APP_API_URL + avatar);
      } else {
        return (this.avatarImageUrl =
          Keys.VUE_APP_API_URL + '/storage/avatars/1/avatar.png');
      }
    },
  },
  watch: {
    options(newVal) {
      if (newVal !== this.localOptions) {
        this.localOptions = { ...newVal };
      }
    },
    localOptions(newVal) {
      this.$emit('update:options', newVal);
    },
    search: debounce(function (newVal) {
      this.$emit('update:search', newVal);
    }, 200),
  },
};
</script>
<style lang="scss">
.modulet {
  display: flex;
  align-items: center;
  gap: 14px;
}
.modulet__njesi {
  display: flex;
  align-items: center;
  gap: 6px;
}
.modulet__emer {
  font-size: 0.75rem;
  color: #78909c;
  white-space: nowrap;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
/* Search bar */
.table-search-bar {
  display: flex; align-items: center;
  margin: 12px 16px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1.5px solid rgba(0,0,0,0.1);
  background: rgba(0,0,0,0.02);
  transition: border-color 0.2s;
}
.table-search-bar:focus-within { border-color: #1976D2; }
.table-search-input {
  flex: 1; border: none; outline: none; background: transparent;
  font-size: 14px; color: inherit;
}
.table-search-input::placeholder { color: #94a3b8; }
/* User cell */
.user-cell { display: flex; align-items: center; gap: 10px; padding: 4px 0; }
.user-avatar { flex-shrink: 0; }
.user-cell-info { display: flex; flex-direction: column; min-width: 0; }
.user-cell-name { font-size: 13px; font-weight: 600; line-height: 1.3; }
.user-cell-email { font-size: 11px; color: #94a3b8; }
/* Table rows */
.v-data-table tbody tr:hover { background: rgba(25,118,210,0.04) !important; }
/* Mobile table */
.v-data-table__mobile-row { align-items: flex-start !important; padding: 6px 16px !important; }
.v-data-table__mobile-row__cell { word-break: break-word !important; overflow-wrap: break-word !important; white-space: normal !important; max-width: 55vw; text-align: right; }

/* Kolona e autobuseve: hapesire e qarte mes etiketave */
.bus-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px 0;
  max-width: 260px;
}
.bus-chip {
  font-size: 11.5px !important;
  font-weight: 600;
  height: 26px !important;
  padding: 0 11px !important;
  letter-spacing: 0.2px;
}
.bus-chip:hover { filter: brightness(1.08); }
</style>